// Trigger the guest reward-panel entrance as it becomes visible, instead of on
// page load while it is below the fold. The content remains fully usable without
// JavaScript or when reduced motion is requested.
document.addEventListener('DOMContentLoaded', function () {
  var panel = document.querySelector('.wh-rewards--guest');

  if (!panel || !('IntersectionObserver' in window)) {
    return;
  }

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (reducedMotion.matches) {
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) {
        return;
      }

      panel.classList.add('is-revealed');
      observer.unobserve(panel);
    });
  }, { threshold: 0.28 });

  observer.observe(panel);
});
